import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const Cake = ({ size, ...props }: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M25.965 14.16C25.653 10.428 23.283 7.273 19.996 5.835C19.909 3.706 18.151 2 16 2C13.849 2 12.091 3.706 12.004 5.835C8.717 7.273 6.347 10.428 6.035 14.16C4.853 14.563 4 15.683 4 17C4 18.361 4.912 19.513 6.156 19.878L7.376 25.98C7.842 28.309 9.904 29.999 12.279 29.999H19.72C22.095 29.999 24.157 28.309 24.623 25.98L25.844 19.878C27.088 19.512 28 18.361 28 17C28 15.683 27.147 14.563 25.965 14.16V14.16ZM16 4C17.103 4 18 4.897 18 6C18 7.103 17.103 8 16 8C14.897 8 14 7.103 14 6C14 4.897 14.897 4 16 4ZM22.663 25.588C22.384 26.986 21.146 28 19.721 28H12.28C10.855 28 9.618 26.986 9.338 25.588L8.22 20H12V25C12 25.552 12.448 26 13 26C13.552 26 14 25.552 14 25V20H18V25C18 25.552 18.448 26 19 26C19.552 26 20 25.552 20 25V20H23.78L22.662 25.588H22.663ZM25 18H7C6.449 18 6 17.551 6 17C6 16.449 6.449 16 7 16H9C9.552 16 10 15.552 10 15C10 14.448 9.552 14 9 14H8.062C8.401 11.293 10.099 9.005 12.448 7.836C13.114 9.12 14.456 10 16 10C17.544 10 18.886 9.12 19.552 7.836C21.901 9.005 23.599 11.294 23.938 14H19C18.448 14 18 14.448 18 15C18 15.552 18.448 16 19 16H25C25.551 16 26 16.449 26 17C26 17.551 25.551 18 25 18Z" />
	</svg>
);

export default Cake;
